import React, { useEffect, useState } from "react";
import { CentralModal } from "../CentralModal/CentralModal";
import {
  centralAddLensDetailsService,
  centralGetLensBrandService,
  centralGetLensModelService,
} from "../../../_services";
import { toast } from "react-toastify";
import { CentralSelect } from "../CentralSelect/CentralSelect";
import CentralUploadProofs from "../CentralUploadProofs/CentralUploadProofs";
import "./centralLensDetails.css";
import { centralReportingDataActions } from "../../../_actions";
import { useDispatch } from "react-redux";

const CentralLensModal = (props) => {
  const { open, onClose, onOpen, appointmentId } = props;
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [lensBrandsDetails, setLensBrandsDetails] = useState([]);
  const [lensModelsDetails, setLensModelsDetails] = useState({
    dropDownModels:[],
    allModels:[]
  });
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    lensBrand: "",
    lensModel: "",
    lensProof: "",
    lensType: "",
  });

  useEffect(() => {
    if (open) {
      centralGetLensBrandService()
        .then((response) => {
          console.log("response...", response.data, open);
          if (
            response &&
            response.status === 200 &&
            response?.data?.length > 0
          ) {
            const brands = response?.data.map((item) => ({
              label: item,
              value: item,
            }));
            setLensBrandsDetails(brands);
          } else {
            toast.error("Lens Brand is not available");
          }
        })
        .catch((error) => {
          console.error("Error fetching lens brands:", error);
        });
    }
  }, [open]);

  useEffect(() => {
    if (formData.lensBrand && formData.lensModel) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [formData]);

  const getLensModel = (brand) => {
    setFormData((prevData) => ({
      ...prevData,
      lensModel: "",
      lensType: "",
    }));

    if (brand) {
      centralGetLensModelService(brand)
        .then((response) => {
          if (
            response &&
            response.status === 200 &&
            response?.data?.length > 0
          ) {
            const models = response?.data.map((item) => ({
              label: item.model,
              value: item.model,
            }));
            setLensModelsDetails({
              dropDownModels: models,
              allModels: response.data,
            });
          } else {
            toast.error("Lens Models is not available");
            setLensModelsDetails({ dropDownModels: [], allModels: [] });
          }
        })
        .catch((error) => {
          console.error("Error fetching lens models:", error);
          setLensModelsDetails({ dropDownModels: [], allModels: [] });
        })
        .finally(() => {
          setFormData((prev) => ({ ...prev, lensModel: "", lensType: "" }));
        });
    }else {
      setLensModelsDetails({ dropDownModels: [], allModels: [] });
    }
  };

  const handleOnClose = () => {
    onClose();
    setFormData((prev) => ({
      ...prev,
      lensBrand: "",
      lensProof: "",
      lensModel: "",
    }));
  };

  const handleOnSubmit = () => {
    if (
      !formData.lensBrand ||
      !formData.lensType ||
      !appointmentId ||
      !formData.lensModel
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const params = {
      brand: formData.lensBrand,
      lensType: formData.lensType,
      appointmentId: appointmentId,
      model: formData.lensModel,
      proofURL: formData.lensProof,
      source: "hosChatApp",
    };

    centralAddLensDetailsService(params)
      .then((res) => {
        if (res.status === 200) {
          dispatch(centralReportingDataActions.getCentralReportingData({"search_query":appointmentId}));
          toast.success("Lens details added successfully!");
        } else {
          toast.error("Failed to add lens details.");
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        toast.error("Failed to add lens details.");
      })
      .finally(() => handleOnClose());
  };

  const handleChange = (name, value) => {
    if (name === "lensBrand") {
      getLensModel(value);
    }

    if (name === "lensModel") {
      const selectedModel = lensModelsDetails?.allModels?.find(
        (item) => item.model === value
      );

      setFormData((prevData) => ({
        ...prevData,
        lensModel: value,
        lensType: selectedModel ? selectedModel.lens_type : "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleUploadFile = (urls) => {
    setFormData((prev) => ({
      ...prev,
      lensProof: urls?.length ? urls[0].url : "",
    }));
  };


  return (
    <CentralModal
      modalTitle="Add Lens Details"
      open={open}
      onClose={handleOnClose}
      buttonTitle="Save"
      isShowDivider={true}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleOnSubmit}
      isModalFooterShow={true}
      modalButton={
        <div className="addMoreButton" onClick={() => onOpen()}>
          Add +
        </div>
      }
    >
      <div className="lensModalContainer">
        <CentralSelect
          value={formData.lensBrand || ""}
          label="Lens Brand *"
          options={lensBrandsDetails || []}
          onChange={(event) => handleChange("lensBrand", event.target.value)}
        />
        <CentralSelect
          value={formData.lensModel || ""}
          label="Lens Model *"
          options={lensModelsDetails?.dropDownModels || []}
          disabled={!formData?.lensBrand || !lensModelsDetails?.dropDownModels?.length}
          onChange={(event) => handleChange("lensModel", event.target.value)}
        />
        <CentralUploadProofs
          label="Lens Proof"
          onFileUpload={handleUploadFile}
        />
      </div>
    </CentralModal>
  );
};

export default CentralLensModal;
